/* unplugin-vue-components disabled */import { render } from "./EditDocumentChapter.vue?vue&type=template&id=0a3d3c26&ts=true"
import script from "./EditDocumentChapter.vue?vue&type=script&lang=ts"
export * from "./EditDocumentChapter.vue?vue&type=script&lang=ts"

import "./EditDocumentChapter.vue?vue&type=style&index=0&id=0a3d3c26&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__